export default __webpack_public_path__ + "static/media/Settings_Filled.25a3257c.svg";